var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBattery = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 61,
    viewBox: "0 0 40 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9FADC5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.97 4.334h-5.803V1A.998.998 0 0026.179 0H13.004a.998.998 0 00-.998 1v3.334h-5.51A6.496 6.496 0 000 10.829V54.4a6.496 6.496 0 006.498 6.495H32.97a6.5 6.5 0 006.501-6.496V10.83a6.5 6.5 0 00-6.5-6.495zm2.17 50.064a2.17 2.17 0 01-2.17 2.165H6.496a2.172 2.172 0 01-2.165-2.165V10.83a2.172 2.172 0 012.165-2.164H32.97a2.17 2.17 0 012.17 2.164V54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.193 11.052H7.48a.985.985 0 00-.985.985v41.156c0 .544.44.985.985.985h25.697v-42.14a.985.985 0 00-.985-.986zm-13.82 37.006l-6.512-7.815h4.528l2.62-7.687h-5.551l5.528-15.384h6.283l-3.602 10.4h5.876l-4.215 12.671h4.484l-9.44 7.815z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBattery, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/battery.77b03860.svg";
export { ForwardRef as ReactComponent };